import React from 'react';

const ClockAlertIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
    >
        <path d="M12 6v6l4 2"/>
        <path d="M20 12v5"/>
        <path d="M20 21h.01"/>
        <path d="M21.25 8.2A10 10 0 1 0 16 21.16"/>
    </svg>
);

export default ClockAlertIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/ClockAlertIcon.jsx